import React from 'react'
import { Location } from '@reach/router'
import { Flex } from '@src/components/Boxes'
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
  PinterestShareButton,
  PinterestIcon
} from 'react-share'
import { css } from '@emotion/core'
import { graphql, useStaticQuery } from 'gatsby'

const iconStyle = css`
  margin-right: 15px;
`

const SocialSharing = ({ image }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          devBlogUrl
          blogUrl
        }
      }
    }
  `)

  const { site } = data

  let blogUrl
  if (process.env.BUILD_WEBSITE === 'blog') {
    blogUrl = site.siteMetadata.blogUrl
  } else {
    blogUrl = site.siteMetadata.devBlogUrl
  }

  return (
    <Location>
      {locationProps => {
        const url = locationProps.location.href
        return (
          <Flex>
            <FacebookShareButton url={url} css={iconStyle}>
              <FacebookIcon size={32} path={null} />
            </FacebookShareButton>

            <TwitterShareButton url={url} css={iconStyle}>
              <TwitterIcon size={32} path={null} />
            </TwitterShareButton>

            <LinkedinShareButton url={url} css={iconStyle}>
              <LinkedinIcon size={32} path={null} />
            </LinkedinShareButton>

            <PinterestShareButton
              url={url}
              media={
                image
                  ? blogUrl + image.localFile.publicURL
                  : 'https://dojo-directus.s3.amazonaws.com/uploads/054367e8-bd16-4b40-966a-97228437628d.png'
              }
            >
              <PinterestIcon size={32} path={null} />
            </PinterestShareButton>
          </Flex>
        )
      }}
    </Location>
  )
}

export default SocialSharing
